import { render, staticRenderFns } from "./LeftTabBar.vue?vue&type=template&id=47298af7&scoped=true&"
import script from "./LeftTabBar.vue?vue&type=script&lang=js&"
export * from "./LeftTabBar.vue?vue&type=script&lang=js&"
import style0 from "./LeftTabBar.vue?vue&type=style&index=0&id=47298af7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47298af7",
  null
  
)

export default component.exports